export default "__VITE_ASSET__BCjY0VM1__"